import React from 'react'

import { Box, BoxProps } from '../Box'

export const Container = ({ children, ...rest }: React.PropsWithChildren<BoxProps>) => {
  return (
    <Box maxWidth="100%" mx={['20px', 43, 43 * 2, 43 * 3]} {...rest}>
      {children}
    </Box>
  )
}
